import { DatewiseEvents } from "./datewise-events";

export class MobileCalendarModel {
    public month: number;
    public year: number;
    public get first_day_of_month(): Date {
        return new Date(this.year, this.month, 1);
    }
    public get calendar_view_start_date(): Date {
        return new Date(this.first_day_of_month.getFullYear()
            , this.first_day_of_month.getMonth()
            , ((this.first_day_of_month.getDay() != 0 ? this.first_day_of_month.getDay() - 1 : 6) * -1) + 1);
    }
    public get calendar_view_end_date(): Date {
        let end_date = new Date(this.calendar_view_start_date);
        end_date.setDate(end_date.getDate() + 41);
        return end_date;
    }
    public weeks: Array<Array<DatewiseEvents>>;
    public event_days: Array<DatewiseEvents>;
}